import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import PayrollLedgerComp from './PayrollLedgerComp';

function PayrollLedger() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <PayrollLedgerComp />
      </div>
    </div>
  );
}

export default PayrollLedger;
